import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { disableBodyScroll, enableBodyScroll, BodyScrollOptions } from 'body-scroll-lock';
import { scroll } from '../GlobalStyles/scroll';

const StyledScrollableContainer = styled.div`
    overflow: auto;
    ${scroll('y', true)}

    height: 100%;
    max-height: 100%;
    flex: 1;
`;

export const useScrollLockRef = (options?: BodyScrollOptions, lockCondition = true) => {
    const scrollableRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (scrollableRef.current && lockCondition) {
            const ref = scrollableRef.current;
            disableBodyScroll(ref, options);
            return () => enableBodyScroll(ref);
        }
        return () => {};
    }, [lockCondition, options]);
    return scrollableRef;
};

interface ScrollableAreaProps {
    className?: string;
}

const ScrollableArea: React.FC<ScrollableAreaProps> = ({ children, className }) => {
    const scrollLockRef = useScrollLockRef({ reserveScrollBarGap: true });
    return (
        <StyledScrollableContainer ref={scrollLockRef} className={className}>
            {children}
        </StyledScrollableContainer>
    );
};

export default ScrollableArea;
